import React from 'react';
import './Radio.scss';
import FilledCircle from '../../../static/assets/svg/filled-circle.svg';
import HollowCircle from '../../../static/assets/svg/hollow-circle.svg';

const Radio = ({ className, checked = false, readOnly = false, onClick }) => {
  return (
    <span aria-disabled={checked} className={`rad-color-span ${className || ''}`} onClick={onClick}>
      <span className="rad-label-span">
        <input
          checked={checked}
          className="rad-input-radio"
          readOnly={readOnly}
          type="radio"
          value=""
        />
        <div className="rad-svg-container">
          <img alt="" className="rad-svg-1 rad-svg" src={FilledCircle} />
          {checked ? <img alt="" className="rad-svg-2 rad-svg" src={HollowCircle} /> : ''}
        </div>
      </span>
      <span className="rad-ripple-svg"></span>
    </span>
  );
};

export default Radio;
